import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/list/style/index.tsx